/*
  Valeria Vercelli · Barra de descuento por prendas dentro del carrito de Upcart.
  2 prendas = 10% extra · 3 prendas = 15% extra · 4 prendas = 20% extra · 5 o más = 30% extra (máximo).
  Los descuentos reales son los descuentos automáticos de Shopify «Descuento por prendas: ...».
  Si cambias los porcentajes allí, cámbialos también en TIERS.
*/
(function () {
  if (window.__vvBarraPrendas) return;
  window.__vvBarraPrendas = true;

  var TIERS = [
    { qty: 2, pct: 10 },
    { qty: 3, pct: 15 },
    { qty: 4, pct: 20 }, { qty: 5, pct: 30 }
  ];
  var count = null;

  var CSS =
    '#vv-bdp{padding:14px 20px 4px;font-family:inherit;color:#000;background:transparent}' +
    '#vv-bdp[hidden]{display:none!important}' +
    '.vv-bdp__msg{margin:0 0 14px;text-align:center;font-size:15px;line-height:1.4;color:#000}' +
    '.vv-bdp__msg strong{font-weight:700}' +
    '.vv-bdp__track{position:relative;height:34px;margin:0 36px 44px 4px}' +
    '.vv-bdp__rail{position:absolute;left:0;right:0;top:50%;height:8px;margin-top:-4px;border-radius:10px;background:#e2e2e2;overflow:hidden}' +
    '.vv-bdp__fill{display:block;height:100%;border-radius:10px;background:#000;transition:width .4s ease}' +
    '.vv-bdp__step{position:absolute;top:0;width:34px;height:34px;margin-left:-17px;border-radius:50%;background:#e2e2e2;color:#fff;display:flex;align-items:center;justify-content:center}' +
    '.vv-bdp__step.is-on{background:#000}' +
    '.vv-bdp__step svg{width:17px;height:17px;display:block}' +
    '.vv-bdp__label{position:absolute;top:39px;left:50%;transform:translateX(-50%);white-space:nowrap;text-align:center;font-size:11px;line-height:1.3;color:#000}' +
    '@media (max-width:480px){#vv-bdp{padding:14px 12px 4px}.vv-bdp__track{margin:0 30px 44px 4px}.vv-bdp__label{font-size:10px}}' + '@media (prefers-reduced-motion:reduce){.vv-bdp__fill{transition:none}}';

  var ICON =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" fill-rule="evenodd" ' +
    'd="M3 3h8.2l9.5 9.5a1.5 1.5 0 0 1 0 2.1l-6.1 6.1a1.5 1.5 0 0 1-2.1 0L3 11.2V3Zm4.5 2.3a2.2 2.2 0 1 0 0 4.4 2.2 2.2 0 0 0 0-4.4Z"/></svg>';

  function message(n) {
    if (n >= 5) return '¡Genial! Ya tienes un <strong>30% EXTRA</strong> de descuento';
    for (var i = 0; i < TIERS.length; i++) {
      if (n < TIERS[i].qty) {
        var left = TIERS[i].qty - n;
        if (n === 0) {
          return 'Añade 2 prendas y consigue un <strong>' + TIERS[0].pct + '% EXTRA</strong> de descuento';
        }
        return 'Te falta ' + left + ' prenda' + (left > 1 ? 's' : '') + ' para un <strong>' + TIERS[i].pct + '% EXTRA</strong> de descuento';
      }
    }
    return '';
  }

  function fillPct(n) {
    if (n >= 5) return 100;
    if (n === 4) return 75; if (n === 3) return 50;
    if (n === 2) return 25;
    if (n === 1) return 12.5;
    return 0;
  }

  function markup(n) {
    var steps = '';
    var positions = [25, 50, 75, 100];
    for (var i = 0; i < TIERS.length; i++) {
      steps +=
        '<div class="vv-bdp__step' + (n >= TIERS[i].qty ? ' is-on' : '') + '" style="left:' + positions[i] + '%">' +
        ICON +
        '<span class="vv-bdp__label">' + TIERS[i].pct + '% EXTRA<br>de descuento</span>' +
        '</div>';
    }
    return (
      '<p class="vv-bdp__msg">' + message(n) + '</p>' +
      '<div class="vv-bdp__track">' +
      '<div class="vv-bdp__rail"><span class="vv-bdp__fill" style="width:' + fillPct(n) + '%"></span></div>' +
      steps +
      '</div>'
    );
  }

  function getRoot() {
    var host = document.getElementById('upCart');
    return host && host.shadowRoot;
  }

  function ensure() {
    var root = getRoot();
    if (!root) return;
    if (!root.getElementById('vv-bdp-style')) {
      var style = document.createElement('style');
      style.id = 'vv-bdp-style';
      style.textContent = CSS;
      root.appendChild(style);
    }
    var header = root.querySelector('.upcart-public-header');
    if (!header) return;
    var bar = root.getElementById('vv-bdp');
    if (!bar) {
      bar = document.createElement('div');
      bar.id = 'vv-bdp';
      bar.setAttribute('role', 'progressbar');
      bar.setAttribute('aria-label', 'Descuento por cantidad de prendas');
      bar.setAttribute('aria-valuemin', '0');
      bar.setAttribute('aria-valuemax', '5');
    }
    if (header.nextElementSibling !== bar) header.insertAdjacentElement('afterend', bar);
    if (count === null) {
      bar.hidden = true;
      return;
    }
    bar.hidden = false;
    var key = String(Math.min(count, 5));
    if (bar.getAttribute('data-n') !== key) {
      bar.setAttribute('data-n', key);
      bar.setAttribute('aria-valuenow', key);
      bar.innerHTML = markup(count);
    }
  }

  var timer = null;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          count = cart.item_count || 0;
          ensure();
        })
        .catch(function () {});
    }, 250);
  }

  function isOurs(node) {
    while (node) {
      if (node.id === 'vv-bdp' || node.id === 'vv-bdp-style') return true;
      node = node.parentNode;
    }
    return false;
  }

  function observe() {
    var root = getRoot();
    if (!root) {
      setTimeout(observe, 500);
      return;
    }
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (!isOurs(mutations[i].target)) {
          ensure();
          refresh();
          return;
        }
      }
    }).observe(root, { childList: true, subtree: true });
    ensure();
    refresh();
  }

  var CART_URL = /\/cart\/(add|change|update|clear)/;
  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = originalFetch.apply(this, arguments);
      if (CART_URL.test(url)) p.then(refresh, refresh);
      return p;
    };
  }
  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_URL.test(String(url))) this.addEventListener('loadend', refresh);
    return originalOpen.apply(this, arguments);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
